export const PERMISSIONS = {
    dialer: 'DIALER',
    aiDisposition: 'AI_DISPOSITION',
    campaign: 'CAMPAIGN',
    dialer_campaign: 'CAMPAIGN_DIALER',
    document_generation: 'CAMPAIGN_DOCUMENT_GENERATION',
	knowl_voice_bot_campaign: 'VOICE_BOT_CAMPAIGN',
	craft_ai_bot_campaign: 'CRAFT_AI_BOT_CAMPAIGN',
    userManagement: 'USER_MANAGEMENT'
};